export const STAT_TYPES = {
  BATTING: "batting",
  PITCHING: "pitching",
  LINEUP: "lineup",
  BULLPEN: "bullpen",
  ROSTER: "roster",
  GAMES: "games",
};

